import "../../shared/styles/ViewContainer.css";

const Filtro = ({ form, setForm, params, setParams, setModalPuntoVenta, setSelect }) => {
  const onClick = (e, value) => {
    switch (e.target.name) {
      case "modal_punto_venta":
        {
          setModalPuntoVenta(true);
          setSelect(value);
        }
        break;
    }
  };

  const onChange = (e) => {};

  return (
    <div className="view-toolbar" style={{ marginBottom: '24px' }}>
      <button
        className="btn-add-primary"
        name="modal_punto_venta"
        onClick={(event) => onClick(event, null)}
      >
        <i className="fa fa-plus-circle"></i>
        Agregar Punto de Venta
      </button>

      <div className="search-input-container">
        <input
          type="text"
          className="search-input"
          placeholder="Buscar punto de venta..."
          aria-describedby="basic-addon2"
        />
        <i className="bi bi-search search-icon"></i>
      </div>
    </div>
  );
};

export default Filtro;
